import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { NotificationModel } from '../models/notification.model';
import { API_ENDPOINT$ } from '../shared/index';
import { DataService } from './data.service';
import { MasterDetailResource } from './master-detail-resource';

@Injectable({
  providedIn: 'root'
})
export class NotificationService
  implements MasterDetailResource<NotificationModel, Params, String>
{
  public items: Observable<any[]>;
  public pageSize = 500;
  public pageCount = 0;
  public itemCount = 0;
  public currentPage = 0;
  public pages = [];
  sampleData: NotificationModel[];
  private fetchIssuedAlertsUrl = `${API_ENDPOINT$}/site/fetchIssuedAlerts`;
  private _items: BehaviorSubject<any[]>;
  private _lastQuery: Params | undefined;

  private static compareUsers(
    a: NotificationModel,
    b: NotificationModel,
    attribute: string
  ): number {
    return a.compare(b, attribute);
  }

  constructor(private dataService: DataService) {
    this.sampleData = [];
    // this.sampleData = [
    //   new NotificationModel('1', "#394:486", false,'15', 'Very Critical', 'DG 4', 'Real Time Power','10', '06/11/2019 08:30:00', '5', '06/11/2019 08:30:00'),
    //   new NotificationModel('2', "#395:486", false,'16', 'Very Critical', 'DG 5', 'Real Time Power','10', '06/11/2019 08:30:00', '5', '06/11/2019 08:30:00'),
    //   new NotificationModel('3', "#396:486", false,'17', 'Very Critical', 'DG 6', 'Real Time Power','10', '06/11/2019 08:30:00', '5', '06/11/2019 08:30:00'),
    //   new NotificationModel('4', "#397:486", false,'18', 'Very Critical', 'DG 7', 'Real Time Power','10', '06/11/2019 08:30:00', '5', '06/11/2019 08:30:00'),
    //   new NotificationModel('5', "#398:486", false,'19', 'Very Critical', 'DG 8', 'Real Time Power','10', '06/11/2019 08:30:00', '5', '06/11/2019 08:30:00'),
    // ];
    this._items = new BehaviorSubject<any>([]);
    this.items = this._items
      .asObservable()
      .pipe
      // delay(500) // fake some latency
      ();
  }
  set(data: any) {
    this.sampleData = data;
  }
  queryDepartments(): Observable<Set<string>> {
    return this.items.pipe(
      map((items) => new Set(items.map((user) => user.department)))
    );
  }

  querySingle(id: string): Observable<NotificationModel> {
    return of(this.sampleData.find((value) => value.id === id)).pipe(
      first()
      // delay(500) // fake some latency
    );
  }

  queryAll(params?: Params): Observable<NotificationModel[]> {
    this._lastQuery = params;

    let page = 0;
    let sortAttribute = 'id';

    if (params) {
      if (params.hasOwnProperty('page')) {
        page = +params['page'];
      }

      if (params.hasOwnProperty('sort')) {
        sortAttribute = params['sort'];
      }
    }

    const start = page * this.pageSize;
    const end = start + this.pageSize;
    if (this.sampleData && this.sampleData.length <= 0) {
      return null;
    }

    this.sampleData.sort((a, b) =>
      NotificationService.compareUsers(a, b, sortAttribute)
    );

    const selectedItems = this.sampleData.slice(start, end);

    this.itemCount = selectedItems.length;

    this.computeAvailablePages(page);
    this.currentPage = page;

    this._items.next(selectedItems);

    return this.items;
  }
  getAll(): NotificationModel[] {
    return this.sampleData;
  }
  upsert(site: NotificationModel): NotificationModel {
    const index = this.sampleData.findIndex((value) => value.id === site.id);
    if (index >= 0) {
      this.sampleData[index] = site;
    } else {
      site.id = (this.sampleData.length + 1).toString();
      this.sampleData.push(site);
    }
    this.queryAll(this._lastQuery);
    return site;
  }

  remove(sites: NotificationModel[]) {
    this.sampleData = this.sampleData.filter((site) => sites.indexOf(site) < 0);
    this.queryAll(this._lastQuery);
  }

  private computeAvailablePages(page: number) {
    this.pageCount = Math.ceil(this.sampleData.length / this.pageSize);
    this.pages.length = 0;
    for (let i = 0; i < this.pageCount; i++) {
      this.pages.push({ index: i, active: i === page });
    }
  }

  private generateEntryDate(daysAgo: number) {
    const date = new Date();
    date.setDate(date.getDate() - daysAgo);
    return date;
  }
  public fetchIssuedAlerts(
    siteId: string,
    fromDate: any,
    toDate: any,
    alertForType: string
  ) {
    const t = this;
    t.sampleData = [];
    const model = { siteId, fromDate, toDate, alertForType };
    return new Promise((resolve, reject) => {
      this.dataService
        .postData(this.fetchIssuedAlertsUrl, model)
        .subscribe((data: any) => {
          let i = 0;
          t.sampleData = data.map(function (item) {
            i = i + 1;
            return new NotificationModel(
              i.toString(),
              item.rId,
              item.isRead,
              item.refNo,
              item.criticalityLevel,
              item.alertConditions[0].load.name,
              item.alertConditions[0].parameter,
              item.alertConditions[0].conditionValue,
              item.firstStartTime,
              item.occurrenceCounter,
              item.lastStartTime,
              item.lastEndTime
            );
          });
          resolve(t.sampleData);
        });
    });
  }
}
